const navMenuStyle = Object.freeze({
  buttonVariant: 'primaryOpaque',
  mobile: {
    menuFontStack: 'alt',
  },
});

export default navMenuStyle;
